var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHospitality(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 50,
    viewBox: "0 0 56 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.640284 0H2.68924C3.10941 0 3.35094 0.254861 3.35094 0.405401V18.0973H0V0.405401C0 0.254385 0.220115 0 0.640284 0Z",
    fill: "#620005"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.0003 12.2068H20.1043C21.3715 12.2068 22.5329 12.5074 23.3056 12.9323C24.0783 13.3573 24.3941 13.8427 24.3941 14.2558V18.0973H9.71082V14.2558C9.71082 13.8427 10.0481 13.3573 10.8208 12.9323C11.5935 12.5074 12.7335 12.2068 14.0006 12.2068H14.0003Z",
    fill: "#620005"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 19.4631H16.3699V32.7171H4.88817C4.53041 32.7171 4.20551 33.0425 4.20503 33.4003V49.4495H0.000414045L0 19.4631Z",
    fill: "#620005"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.7347 19.4631H45.7988C51.4154 19.4631 56.0001 24.0689 56.0001 29.6858V49.4485H51.7746V33.3993C51.7746 33.0421 51.4492 32.7167 51.0914 32.7162H17.7345L17.7347 19.4631Z",
    fill: "#620005"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHospitality);
export default __webpack_public_path__ + "static/media/hospitality.6ab4a619b702d41584d6bf24658e220b.svg";
export { ForwardRef as ReactComponent };